import { Component, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'to-loading-shade',
  template: '<mat-spinner></mat-spinner>',
  styleUrls: ['./loading-shade.component.scss']
})
export class LoadingShadeComponent { }

@NgModule({
  imports: [
    MatProgressSpinnerModule,
  ],
  declarations: [
    LoadingShadeComponent,
  ],
  exports: [
    LoadingShadeComponent
  ]
})
export class LoadingShadeModule { }
